import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNorth = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 22C11.7167 22 11.4793 21.904 11.288 21.712C11.096 21.5207 11 21.2833 11 21V5.82499L7.09999 9.69999C6.91665 9.88332 6.68732 9.97932 6.41199 9.98799C6.13732 9.99599 5.89999 9.89999 5.69999 9.69999C5.51665 9.51665 5.42499 9.28332 5.42499 8.99999C5.42499 8.71665 5.51665 8.48332 5.69999 8.29999L11.3 2.69999C11.4 2.59999 11.5083 2.52899 11.625 2.48699C11.7417 2.44565 11.8667 2.42499 12 2.42499C12.1333 2.42499 12.2583 2.44565 12.375 2.48699C12.4917 2.52899 12.6 2.59999 12.7 2.69999L18.3 8.29999C18.4833 8.48332 18.575 8.71232 18.575 8.98699C18.575 9.26232 18.4833 9.49999 18.3 9.69999C18.1 9.89999 17.8623 9.99999 17.587 9.99999C17.3123 9.99999 17.075 9.89999 16.875 9.69999L13 5.82499V21C13 21.2833 12.9043 21.5207 12.713 21.712C12.521 21.904 12.2833 22 12 22Z",
		fill: "currentColor"
	})
});
export default SvgNorth;
